var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcsubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2016_5141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 19.25V0.75H0.75V19.25H19.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2016_5141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5179 7.85983C17.5648 4.1314 14.1798 1.37442 10.1497 1.37442C5.9935 1.37442 2.52347 4.3066 1.69922 8.21252",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6792 11.6876C2.46482 15.6434 5.95848 18.6257 10.15 18.6257C14.5703 18.6257 18.2145 15.3089 18.7249 11.0315",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.585938 12.8273L1.57488 11.0315L3.373 12.0191",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7178 7.40186L18.6026 8.21252L19.4142 6.33015",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4162 7.88437V7.79007C13.4162 6.8807 12.6781 6.14351 11.7676 6.14351H8.23212C7.32162 6.14351 6.5835 6.8807 6.5835 7.79007C6.5835 8.40772 6.99537 8.94983 7.59099 9.11608L12.4088 10.461C13.0044 10.6273 13.4162 11.1694 13.4162 11.787V12.1267C13.4162 13.0361 12.6781 13.7733 11.7676 13.7733H8.23212C7.32162 13.7733 6.5835 13.0361 6.5835 12.1267V11.892",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06201 4.59787V15.4021V4.59787Z",
    fill: "#26C3C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06201 4.59787V15.4021",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.938 4.59787V15.4021V4.59787Z",
    fill: "#26C3C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.938 4.59787V15.4021",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcsubscription);
export default __webpack_public_path__ + "static/media/icsubscription.11fc82dfd109d9f415f517ab41de2b5a.svg";
export { ForwardRef as ReactComponent };